export const letterSpacings = {
  tighter: '-0.05rem',
  tight: '-0.025rem',
  snug: '-0.01em',
  normal: '0',
  wide: '0.025rem',
  wider: '0.05rem',
  widest: '0.1rem',
};
